import { PropsWithChildren, SetStateAction, createContext, useContext, useState } from "react";

const CreateHandbookContext = createContext<CreateHandbookContextType>({
  setIsSectionCreating: () => {},
});

export const CreateHandbookProvider = ({ children }: PropsWithChildren) => {
  const [isSectionCreating, setIsSectionCreating] = useState(false);

  return (
    <CreateHandbookContext.Provider value={{ isSectionCreating, setIsSectionCreating }}>
      {children}
    </CreateHandbookContext.Provider>
  );
};

export const useCreateHandbookContext = () => useContext(CreateHandbookContext);

type CreateHandbookContextType = {
  isSectionCreating?: boolean;
  setIsSectionCreating: React.Dispatch<SetStateAction<boolean>>;
};
